import { Component, HostListener, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common'
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { APIService } from '../backend-service/backend-service';
import { environment } from '../../../environments/environment';
import { SharedService } from '../../share-data/shared.service';
import { NotificationService } from '../../shared/services/notification.service';
import { LoadingService } from '../../services/loading.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../transport-management/confirm-dialog/confirm-dialog.component';
import { Subscription } from 'rxjs';
import { PhoneFormatPipe } from '../../shared/pipes/phone-format.pipe';

@Component({
  selector: 'app-driver-profile',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    MatInputModule,
    CommonModule,
    MatChipsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatIconModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    PhoneFormatPipe
  ],
  templateUrl: './driver-profile.component.html',
  styleUrl: './driver-profile.component.scss'
})
export class DriverProfileComponent implements OnDestroy {
  selectedDriverId: string | null = null;
  dropdownPosition = { top: '0px', right: '0px' };
  searchText: string = '';
  datas: any[] = [];
  currentPage: number = 1;
  totalPages: number = 1;
  pageSize: number = 10;
  pages: number[] = [];
  isLoading: boolean = false;
  private loadingSubscription: Subscription;

  constructor(private router: Router, private apiService: APIService, private sharedService: SharedService,
    private notification: NotificationService, public loadingService: LoadingService,
    private dialog: MatDialog) {
    this.loadingSubscription = this.loadingService.isLoading$.subscribe(loading => this.isLoading = loading);
  }

  ngOnInit() {
    this.getDriverList();
    // this.datas = [
    //   { name: 'Meas Vichet', photo: 'assets/img/mark.png', phoneNumber: '0969876543' },
    //   { name: 'Sok Tola', photo: 'assets/img/jeff.png', phoneNumber: '012345678' },
    //   { name: 'Oum Bora', photo: 'assets/img/mask.png', phoneNumber: '0975556666' },
    // ];
  }
  getDriverList(page: number = 1) {
    this.datas = [];
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    console.log("LoginData: ", loginData)
    this.apiService.get(`/api/drivers?page=${page}&limit=${this.pageSize}`, loginData.token).subscribe({
      next: (response) => {
        console.log('Status:', response.status);
        console.log('/api/driver/list' + ',\n' + 'driver_List_Response:', response.body);
        if (response.status === 200) {
          response.body.drivers.forEach((data: { [x: string]: any; }) => {
            try {
              this.datas.push({
                ...data,
                url: environment.imageUrl,
                driverPicURL: environment.imageUrl + data['picture'],
                nidPicURL: environment.imageUrl + data['nidPicture'],
                driverLicenseURL: environment.imageUrl + data['driverLicensePicture'],
                criminalRecordDocumentURL: environment.imageUrl + data['criminalRecordDocument'],
              })
            } catch (error) {

            }
          });
          this.totalPages = response.body.pagination.totalPages;
          this.pages = Array(this.totalPages).fill(0).map((_, i) => i + 1);
          this.currentPage = page;
        }
        else {
          console.log("Hey you")
        }
      },
      error: (error) => {
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
      }
    });
  }
  addNewDriver() {
    this.router.navigate(['/home/driver-profile/driver-registration']);
  }
  get filteredOrders() {
    if (!this.searchText) {
      return this.datas;
    }
    const searchLower = this.searchText.toLowerCase();
    return this.datas.filter(data => {
      const khmerName = data.khmerName?.toLowerCase() || '';
      const englishName = data.englishName?.toLowerCase() || '';
      const phoneNumber = data.primaryContactNumber || '';
      return khmerName.includes(searchLower) ||
        englishName.includes(searchLower) ||
        phoneNumber.includes(this.searchText);
    });
  }

  get pagedOrders() {
    return this.filteredOrders;
  }
  editDriver(data: any, event: MouseEvent) {
    console.log("Selected Id: ", data.id)
    if (this.selectedDriverId === data.id) {
      this.selectedDriverId = null;
    } else {
      const btn = event.currentTarget as HTMLElement;
      const rect = btn.getBoundingClientRect();
      this.dropdownPosition = {
        top: `${rect.bottom + 4}px`,
        right: `${Math.max(window.innerWidth - rect.right, 8)}px`,
      };
      this.selectedDriverId = data.id;
    }
  }
  onEdit(data: any) {
    this.selectedDriverId = null;
    this.sharedService.setData(data);
    this.router.navigate(
      ['/home/driver-profile/driver-registration/:id'],
      { queryParams: { isEdit: true } }
    );
  }
  onDelete(data: any) {
    this.selectedDriverId = null;
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '420px',
      data: { plateNumber: data.englishName, title: 'Delete Driver', confirmLabel: 'Delete', message: 'Are you sure you want to delete driver' }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.deleteCustomer(data);
      }
    });
  }
  deleteCustomer(data: any) {
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    this.apiService.delete('/api/drivers/' + data.id, loginData.token).subscribe({
      next: (response) => {
        console.log('Status:', response.status);
        console.log('/api/drivers/delete' + ',\n' + 'Driver_Delete_Response:', response);
        this.notification.success(response.message || 'Operation completed successfully');
        this.getDriverList();
      },
      error: (error) => {
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
      }
    });
  }

  // filterCustomerByPrimaryContact(customer: Customer): Customer | null {
  //   const hasPrimaryContact = customer.contacts?.some(contact => contact.isPrimary);
  //   return hasPrimaryContact ? customer : null;
  // }


  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;

    // Only close the dropdown if clicked outside any dropdown-related button or menu
    if (!target.closest('.btn-icon-action') && !target.closest('.dropdown-menu')) {
      this.selectedDriverId = null;
    }
  }

  ngOnDestroy() {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
  }
}
